angular.module('app.entity.audit').component('auditFieldIcon', {
    templateUrl: 'modules/ecrd/components/audit/components/field-icon/template.html',
    bindings: {
        fieldId: '<',
        uidPrefix: '<',
        onToggle: '&',
    },
    controller: ['$scope', '$stateParams', 'RecordAuditFields', 'Event', function($scope, $stateParams, RecordAuditFields, Event) {
        var vm = this;

        vm.visible = false;
        vm.watcher = null;

        vm.$onInit = function() {
            // Calcular el UID del campo asociado
            vm.fieldUId = (vm.uidPrefix ? vm.uidPrefix + '.' : '') + vm.fieldId;

            // Recargar info
            reload(vm);

            vm.watcher = $scope.$watch('$ctrl.visible', function(newValue, oldValue) {
                $scope.$emit('iconAuditUpdated', newValue);
            });
        };

        vm.$onDestroy = function() {
            vm.watcher && vm.watcher();
        };

        Event.on(RecordAuditFields.EVENTS.INFO_UPDATED, function() {
            reload(vm);
        });

        function reload(ctrl) {
            ctrl.visible = RecordAuditFields.fieldIconIsEnabled(ctrl.fieldUId);
        }
    }],
});
